import React from "react";
import {typeNodeData} from "./nodeConfig";

export const typeNodeProvider = {
    getOptions ,
    getItem
};

async function getOptions() {
    try {
        return typeNodeData.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <div><label>{item.code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getItem(id) {
    if (!id)
        return null;

    const item = typeNodeData.find(tvd => tvd.id === id)
    try {
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>,
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}